<!-- <div class="px-5 py-3" style="height: 100vh; overflow: auto;"> -->
  <!-- Trial Banner -->
  <div class="trial-banner mb-4">
    <div class="row align-items-center">
      <div class="col-lg-8">
        <div class="tbadge d-flex flex-wrap align-items-center gap-2 mb-2">
          <span class="trial-badge">
            <i class="bi bi-mortarboard-fill"></i>
            ERP Trial Account
          </span>
          <span class="trial-badge">
            <i class="bi bi-calendar-week"></i>
            Expires: {{dataService.ymd2dmy(expDate)}}
          </span>
        </div>

        <h4 class="mb-2 fw-bold">
          Your Free Trial is {{(dayRemains < 0) ? 'Over' : 'Active' }} 
        </h4>

            <p class="mb-0">
              Explore all ERP features including Admissions,
              Fees Management, HR, Transport, Exams and Reports.
              Upgrade before expiry to avoid service interruption.
            </p>
      </div>
      <div class="col-lg-4">
        <div class="w-100 text-end mb-3" style="width: 150px;">
          <div class="days-left">
            {{dayRemains}}
          </div>
          <small>Days Remaining</small>
        </div>

        <div class="w-100 text-lg-end banner-action">
          <button class="upgrade-btn mb-2" (click)="upgrade()" data-bs-dismiss="modal">
            Subscribe
          </button>
          <button class="trial-btn" (click)="continue()" data-bs-dismiss="modal" [hidden]="dayRemains <= 0">
            Continue Trial
          </button>
          <button class="trial-btn" (click)="dataService.auth.logout()" data-bs-dismiss="modal" [hidden]="dayRemains > 0">
            Logout & Exit
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Dashboard Widgets -->
  <div class="row g-4">
    <!-- Trial Usage -->
    <div class="col-lg-6">
      <div class="card trial-card h-100">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="mb-0">
              Trial Usage
            </h5>
            <span class="badge bg-warning text-dark">
              Trial Plan
            </span>
          </div>

          <div class="mb-3">
            <label class="fw-semibold mb-2">
              Trial Consumption
            </label>
            <div class="progress">
              <div class="progress-bar bg-danger" [ngStyle]="{'width': trialUsage + '%'}">
                <!-- {{trialUsage}}% --> Day {{dayConsumed}}
              </div>
            </div>
          </div>

          <div class="row g-2 mt-2">
            <div class="col-6">
              <div class="stat-box">
                <div class="stat-value">850</div>
                <small>Students Added</small>
              </div>
            </div>

            <div class="col-6">
              <div class="stat-box">
                <div class="stat-value">25</div>
                <small>Staff Added</small>
              </div>
            </div>

            <div class="col-6">
              <div class="stat-box">
                <div class="stat-value">11/15</div>
                <small>Days Used</small>
              </div>
            </div>

            <div class="col-6">
              <div class="stat-box">
                <div class="stat-value">0</div>
                <small>Plan / Package</small>
              </div>
            </div>

            <div class="col-6">
              <div class="stat-box">
                <div class="stat-value">35</div>
                <small>Transports</small>
              </div>
            </div>

            <div class="col-6">
              <div class="stat-box">
                <div class="stat-value">7</div>
                <small>Pending Tasks</small>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Trial Features -->
    <div class="col-lg-6">
      <div class="card trial-card h-100">
        <div class="card-body">
          <h5 class="mb-4">
            Trial Features & Limits
          </h5>

          <ul class="list-unstyled feature-list">
            <li>
              <i class="bi bi-check-square-fill text-success"></i> Student Management
            </li>
            <li>
              <i class="bi bi-check-square-fill text-success"></i> Attendance Management
            </li>
            <li>
              <i class="bi bi-check-square-fill text-success"></i> Fee Collection
            </li>
            <li>
              <i class="bi bi-check-square-fill text-success"></i> HR & Payroll
            </li>
            <li>
              <i class="bi bi-check-square-fill text-success"></i> Exam & Result Management
            </li>
            <li>
              <i class="bi bi-exclamation-square"></i> Limited SMS Credits
            </li>
            <li>
              <i class="bi bi-exclamation-square"></i> Limited WhatsApp Messages
            </li>
            <li>
              <i class="bi bi-x-square-fill text-danger"></i> Custom Domain Not Available
            </li>
          </ul>

          <div class="alert alert-warning mt-3 mb-0">
            Upgrade to unlock unlimited users, SMS,
            WhatsApp integration, custom branding and
            advanced analytics.
          </div>

        </div>
      </div>
    </div>
  </div>
<!-- </div> -->